/* eslint new-cap: 0 */
import isMobile from 'ismobilejs';

export default class IntercomJsClient {
  constructor(restClient, { appId }) {
    this._restClient = restClient;
    this._currentUserId = '';
    this._appId = appId;
  }

  boot(data) {
    console.debug('intercomClient.boot', data);
    this._currentUserId = data.user_id;
    window.Intercom('boot', { ...data, app_id: this._appId });
    return true;
  }

  update(data) {
    const { userId, ...restOfData } = data;
    if (userId && userId !== this._currentUserId) {
      return this._restClient.update(data);
    }
    window.Intercom('update', restOfData);
    return true;
  }

  trackEvent(eventName, metadata) {
    const {phone, tablet} = isMobile;
    const deviceInfo = {};
    if (phone) {
      deviceInfo.phone = true;
    } else if (tablet) {
      deviceInfo.tablet = true;
    } else {
      deviceInfo.desktop = true;
    }
    const {userId, id} = metadata;
    if (!userId && id) {
      return this._restClient.trackEvent(eventName, metadata);
    }
    if (userId && userId !== this._currentUserId) {
      return this._restClient.trackEvent(eventName, metadata);
    }
    window.Intercom('trackEvent', eventName, {...metadata, deviceInfo});
    return true;
  }

  shutdown() {
    window.Intercom('shutdown');
    return true;
  }

  hide() {
    window.Intercom('hide');
    return true;
  }

  show() {
    window.Intercom('show');
    return true;
  }

  showNewMessage(message) {
    window.Intercom('showNewMessage', message);
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/services/intercomJsClient.js